<main
  class="login-page-wrapper"
>
  <section
    class="branding-panel"
  >
    <a
      class="branding-logo-tile"
      routerLink="/login"
    >
      <img
        class="branding-logo-img"
        src="assets/logos/pi-signage-full-logo.svg"
        alt="PI Signage"
      >
    </a>
    <div
      class="branding-content"
    >
      <p
        class="branding-tag"
      >
        Account invitation
      </p>
      <h1
        class="branding-heading"
      >
        Join your organization workspace.
      </h1>
      <p
        class="branding-subtext"
      >
        Activate your account to collaborate with the team managing PI Signage.
      </p>
    </div>
  </section>

  <section
    class="login-panel"
  >
    <div
      class="login-card"
    >
      <span
        class="login-welcome"
      >
        You are invited
      </span>
      <h2
        class="login-title"
      >
        Join your organization
      </h2>

      <p
        *ngIf="isLoading"
        class="login-description"
      >
        Loading invitation…
      </p>

      <div
        *ngIf="invitation"
        class="invitation-summary"
      >
        <strong>{{ invitation.organization.name }}</strong>
        <span>{{ invitation.email }} · {{ invitation.role.name }}</span>
      </div>

      <form
        *ngIf="invitation"
        #inviteForm="ngForm"
        (ngSubmit)="onSubmit()"
      >
        <div
          class="form-grid"
        >
          <div
            class="login-field-group"
          >
            <label
              for="inviteFirstName"
            >
              First name
            </label>
            <input
              pInputText
              class="login-input"
              id="inviteFirstName"
              name="firstName"
              autocomplete="given-name"
              [(ngModel)]="firstName"
              required
            >
          </div>
          <div
            class="login-field-group"
          >
            <label
              for="inviteLastName"
            >
              Last name
            </label>
            <input
              pInputText
              class="login-input"
              id="inviteLastName"
              name="lastName"
              autocomplete="family-name"
              [(ngModel)]="lastName"
              required
            >
          </div>
        </div>

        <div
          class="login-field-group"
        >
          <label
            for="invitePassword"
          >
            Password
          </label>
          <input
            pInputText
            class="login-input"
            id="invitePassword"
            name="password"
            type="password"
            autocomplete="new-password"
            [(ngModel)]="password"
            minlength="8"
            required
          >
        </div>

        <div
          class="login-field-group"
        >
          <label
            for="inviteConfirmPassword"
          >
            Confirm password
          </label>
          <input
            pInputText
            class="login-input"
            id="inviteConfirmPassword"
            name="confirmPassword"
            type="password"
            autocomplete="new-password"
            [(ngModel)]="confirmPassword"
            minlength="8"
            required
          >
        </div>
        <p
          class="field-help"
        >
          Use 8+ characters with an uppercase letter, number, and symbol.
        </p>

        <button
          class="login-btn login-btn-primary"
          type="submit"
          [disabled]="inviteForm.invalid || isSubmitting"
        >
          {{ isSubmitting ? 'Activating account…' : 'Accept invitation' }}
        </button>
      </form>

      <p
        *ngIf="errorMessage"
        class="alert error"
        role="alert"
      >
        {{ errorMessage }}
      </p>
    </div>
  </section>
</main>
